export const Logo = ({ size = "md", className = "", light = true }) => {
  const s = {
    sm: ["text-[22px] tracking-[0.18em]", "text-[8px] tracking-[0.62em] mt-0.5"],
    md: ["text-[28px] tracking-[0.18em]", "text-[9px] tracking-[0.66em] mt-1"],
    xl: ["text-[15vw] sm:text-7xl lg:text-[8.5rem] tracking-[0.12em]", "text-xs sm:text-base lg:text-xl tracking-[0.8em] mt-2"],
  }[size];
  return (
    <span className={`inline-flex flex-col items-center leading-none font-display ${className}`} data-testid="brand-logo">
      <span className={`${s[0]} font-normal ${light ? "text-ivory" : "text-midnight"}`}>
        MEVA<span className="text-gold">LUX</span>
      </span>
      <span className={`${s[1]} font-sans font-light pl-[0.6em] ${light ? "text-ivory/80" : "text-midnight/70"}`}>PROPERTY</span>
    </span>
  );
};
